import { useEffect } from "react";
import { useToast } from "../../context/ToastProvider";
import { consumePendingToast } from "../../lib/pendingToast";

/**
 * Drains the one-shot toast the storefront wizard embed stashes before it
 * navigates into the app (`lib/pendingToast.ts`). Mounted once in `<App>`
 * inside ToastProvider; renders nothing. Consuming clears the entry, so a
 * StrictMode double-run (or a later remount) finds nothing to show.
 */
export function PendingToast() {
  const { push } = useToast();
  useEffect(() => {
    const toast = consumePendingToast();
    if (toast) push(toast);
  }, [push]);
  return null;
}
